import { useNavigate } from "react-router-dom";
import { NEWS_LIST_ROUTE, NEWS_ADD_ROUTE } from "constants/routeEnum";
import callApi from "Common/utils/apiCaller";
import { showNotification } from "Common/utils/Notification";
import { useState, useEffect } from "react";
import { TailSpin } from "react-loader-spinner";
import { imageUploader } from "Common/utils/imageUploader";
import { createSelector } from "reselect";
import { useSelector, useDispatch } from "react-redux";
import { getImageUrl } from "Common/utils/ImageDomain";
import { ToastContainer } from "react-toastify";
import PermissionSwitch from "../../Common/Components/PermissionLocks/PermissionSwitch";
import BreadCrumb from "../../Common/BreadCrumb";
import { validateURL } from "Common/utils/Validation";
import CustomDateInput from "Common/Components/InputFields/CustomDateInput";
import moment from "moment";
import Drawer from "Common/Components/Drawer";
import ImageView from "Common/Components/ImageView/ImageView";
import ImageData from "Common/Components/customImage/Image";
import { X } from "lucide-react";

const AddNews = () => {
  const navigate = useNavigate();

  const [newsHeading, setNewsHeading] = useState<any>("");
  const [newsDate, setNewsDate] = useState<any>(moment().toISOString());
  const [newsDateError, setNewsDateError] = useState<any>("");
  const [newsHeadingError, setNewsHeadingError] = useState<any>("");
  const [newsLinkError, setNewsLinkError] = useState<any>("");
  const [newsLink, setNewsLink] = useState<any>("");
  const [loader, setLoader] = useState<any>(false);
  const [showImage, setShowImage] = useState<any>(false);
  const toggleImage = () => setShowImage(!showImage);
  const [imageData, setImageData] = useState<any>("");
  const [imageLink, setImageLink] = useState<any>();

  useEffect(() => {
    if (imageData && imageData?.media_url) {
      if (imageData?.content_type?.split("/")[0] === "image") {
        setImageLink(imageData);
      } else {
        showNotification("Please Select Image", "error");
      }
    }
  }, [imageData]);

  const selectProperties = createSelector(
    (state: any) => state.Login,
    (profile) => ({
      permission: profile.permission,
      user: profile.user,
    })
  );

  const { permission, user } = useSelector(selectProperties);

  const userHasPermission = () => {
    return permission?.permissions?.includes("news:create");
  };

  const validateNews = () => {
    let isValid = true;
    if (!newsLink) {
      setNewsLinkError("Please enter link");
      isValid = false;
    }
    if (!newsDate) {
      setNewsDateError("Please select news date");
      isValid = false;
    }
    if (!newsHeading) {
      setNewsHeadingError("Please enter heading");
      isValid = false;
    }
    return isValid;
  };

  const handleSubmit = async () => {
    console.log(newsLink, newsDate, newsHeading);
    if (validateNews()) {
      // if (!!!imageLink?.media_url) {
      //   showNotification("Please add image", "error");
      //   return;
      // }
      try {
        setLoader(true);
        const res = await callApi(`v1/news/new`, "post", {
          news: {
            external_link: newsLink,
            heading: newsHeading,

            news_date: newsDate,
            thumbnail_url: imageLink?.media_url,
            thumbnail_media_id: imageLink?._id,

            released_at: newsDate,

          },
        });
        setLoader(false);
        if (res && res?.status === "Success") {
          showNotification("News created successfully", "success");
          setLoader(true);
          setTimeout(() => {
            navigate(NEWS_LIST_ROUTE);
            setLoader(false);
          }, 500);
        }
      } catch (e) {
        showNotification("something went wrong", "error");
        setLoader(false);
      }
    }
  };

  return (
    <>
      <BreadCrumb
        title={NEWS_ADD_ROUTE}
        pageTitle={NEWS_LIST_ROUTE}
        version="v1"
      />
      <ToastContainer />
      <div className="grid grid-cols-12 gap-x-5">
        <div className="col-span-12 card 2xl:col-span-12">
          <div className="p-6">
            <form
              className="create-form"
              id="create-form"
              onSubmit={(e) => {
                e.preventDefault();
                if (userHasPermission()) {
                  handleSubmit();
                } else {
                  showNotification(
                    "You don't have permission to create news",
                    "error"
                  );
                }
                return false;
              }}
            >
              <input type="hidden" value="" name="id" id="id" />
              <input type="hidden" value="add" name="action" id="action" />
              <input type="hidden" id="id-field" />
              <div
                id="alert-error-msg"
                className="hidden px-4 py-3 text-sm text-red-500 border border-transparent rounded-md bg-red-50 dark:bg-red-500/20"
              ></div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <CustomDateInput
                    isDisabled={!userHasPermission()}
                    value={newsDate}
                    dateOptions={{ dateFormat: "Y-m-d" }}
                    isRequired={true}
                    keyName="released_at"
                    label="News Date"
                    setDate={(selectedDates) => {
                      setNewsDate(selectedDates[0].toISOString());
                    }}
                    placeholder="Select Date"

                  

                    errors={{ "released_at": newsDateError }}

                  />
                </div>
              </div>
              <div className="grid grid-cols-1 gap-4 xl:grid-cols-12">
                <div className="xl:col-span-12">
                  <label
                    htmlFor="phoneNumberInput3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Heading
                  </label>
                  <input
                    disabled={!userHasPermission()}
                    type="text"
                    id="phoneNumberInput3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter Heading"
                    name="heading"
                    onChange={(e) => setNewsHeading(e.target.value)}
                    value={newsHeading || ""}
                  />
                  {newsHeadingError ? (
                    <p className="text-red-400">{newsHeadingError}</p>
                  ) : null}
                </div>

                <div className="mt-4 xl:col-span-12">
                  <label
                    htmlFor="link3"
                    className="inline-block mb-2 text-base font-medium"
                  >
                    Link
                  </label>
                  <input
                    type="text"
                    disabled={!userHasPermission()}
                    id="link3"
                    className="form-input border-slate-200 dark:border-zink-500 focus:outline-none focus:border-custom-500 disabled:bg-slate-100 dark:disabled:bg-zink-600 disabled:border-slate-300 dark:disabled:border-zink-500 dark:disabled:text-zink-200 disabled:text-slate-500 dark:text-zink-100 dark:bg-zink-700 dark:focus:border-custom-800 placeholder:text-slate-400 dark:placeholder:text-zink-200"
                    placeholder="Enter link"
                    onChange={(e) => setNewsLink(e.target.value)}
                    value={newsLink || ""}
                  />
                  {newsLinkError ? (
                    <p className="text-red-400">{newsLinkError}</p>
                  ) : null}
                </div>
              </div>
              {/* <div className="m-4 ml-0 xl:col-span-12">
                {imageLink ? (
                  <div className="flex items-center">
                    <ImageData
                      imageLink={imageLink}
                      setImageLink={setImageLink}
                      setImageData={setImageData}
                    />
                    <div className="h-3 ml-3">
                      <div
                        onClick={() => {
                          setImageData(undefined);
                          toggleImage();
                        }}
                        className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                      >
                        Change
                      </div>
                    </div>
                  </div>
                ) : (
                  <>
                    <div
                      onClick={() => {
                        setImageData(undefined);
                        toggleImage();
                      }}
                      className="text-white cursor-pointer btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                    >
                      {"Add Thumbnail"}
                    </div>
                  </>
                )}
              </div> */}

              <div className="flex justify-end gap-2 mt-4">
                <button
                  type="reset"
                  id="close-modal"
                  data-modal-close="addEmployeeModal"
                  className="text-red-500 bg-white btn hover:text-red-500 hover:bg-red-100 focus:text-red-500 focus:bg-red-100 active:text-red-500 active:bg-red-100 dark:bg-zink-600 dark:hover:bg-red-500/10 dark:focus:bg-red-500/10 dark:active:bg-red-500/10"
                  onClick={() => navigate(NEWS_LIST_ROUTE)}
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  disabled={loader || !userHasPermission()}
                  id="addNew"
                  style={{
                    minWidth: "130px",
                    display: "flex",
                    justifyContent: "center",
                  }}
                  className="text-white btn bg-custom-500 border-custom-500 hover:text-white hover:bg-custom-600 hover:border-custom-600 focus:text-white focus:bg-custom-600 focus:border-custom-600 focus:ring focus:ring-custom-100 active:text-white active:bg-custom-600 active:border-custom-600 active:ring active:ring-custom-100 dark:ring-custom-400/20"
                >
                  {loader ? (
                    <span>
                      <TailSpin
                        visible={true}
                        height="20"
                        width="20"
                        color="#fff"
                      />
                    </span>
                  ) : (
                    "Add news"
                  )}
                </button>
              </div>
            </form>
          </div>
        </div>
      </div>
      <Drawer
        show={showImage}
        onHide={toggleImage}
        id="drawerEnd"
        drawer-end="true"
        className="fixed inset-y-0 flex flex-col w-1/2 transition-transform duration-300 ease-in-out transform bg-white shadow ltr:right-0 rtl:left-0 z-drawer dark:bg-zink-600"
      >
        <Drawer.Header
          className="flex items-center justify-between p-4 border-b card-body border-slate-200 dark:border-zink-500"
          closeButtonClass="lucide lucide-x size-4 transition-all duration-200 ease-linear text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"
        >
          <Drawer.Title className="text-15">{"Select Image"}</Drawer.Title>
          <X className="transition-all duration-200 ease-linear size-4 text-slate-500 hover:text-slate-700 dark:text-zink-200 dark:hover:text-zink-50"></X>
        </Drawer.Header>
        <Drawer.Body className="h-full p-4 overflow-y-auto">
          <ImageView
            showImage={showImage}
            setEventData={setImageData}
            togleImage={toggleImage}
          />
        </Drawer.Body>
      </Drawer>
    </>
  );
};

export default AddNews;
